<template>
  <div class="lesson-quiz-card-container" :class="`status-${status}`">
    <div v-if="!status" class="lesson-quiz-card">
      <HMButton color="brand" @click="$emit('startQuiz')">
        {{ $t('QUIZZES.BUTTON.TAKE_THE_QUIZ') }}
      </HMButton>
      <span class="smaller mt-4" v-if="!retakeAllowed">
        {{ $t('QUIZZES.TEXT.QUIZ_ALLOWS_ONLY_ONE_SUBMISSION') }}
      </span>
      <span v-else class="smaller mt-4">
        {{ $t('QUIZZES.TEXT.IF_FAIL_YOU_WILL_BE_ABLE_TO_RETAKE') }}
      </span>
    </div>
    <div v-else-if="status === 'failed'" class="lesson-quiz-card">
      <div class="icon-container">
        <i class="far fa-sad-tear"></i>
      </div>
      <p class="c-charcoal py-2">
        {{ $t('QUIZZES.TEXT.YOU_DIDNOT_PASS_THE_QUIZ') }}
      </p>
      <div v-if="retakeAllowed">
        <HMButton color="brand" @click="$emit('retakeQuiz')">
          {{ $t('QUIZZES.BUTTON.RETAKE_THE_QUIZ') }}
        </HMButton>
      </div>
      <div v-else>
        <span class="smaller mt-2">
          {{ $t('QUIZZES.TEXT.TALK_TO_INSTRUCTOR_TO_RETAKE_QUIZ') }}
        </span>
      </div>
    </div>
    <div v-else-if="status === 'passed'" class="lesson-quiz-card">
      <div class="icon-container">
        <i class="far fa-check"></i>
      </div>
      <p class="c-charcoal py-2">
        {{ $t('QUIZZES.TEXT.YOU_PASSED_THE_QUIZ') }}
      </p>
      <span class="smaller mt-2">
        {{ $t('QUIZZES.TEXT.WONT_HAVE_TO_TAKE_THE_QUIZ_AGAIN') }}
      </span>
    </div>
    <div v-else-if="status === 'review'" class="lesson-quiz-card">
      <div class="icon-container">
        <i class="far fa-clock"></i>
      </div>
      <p class="c-charcoal py-2">
        {{ $t('QUIZZES.TEXT.QUIZ_IN_REVIEW') }}
      </p>
      <span class="smaller mt-2">
        {{ $t('QUIZZES.TEXT.ALLOW_TIME_FOR_TEACHER_TO_GRADE_YOUR_ANSWERS') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudioLessonQuizCard',
  props: {
    status: {
      type: String,
    },
    retakeAllowed: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.lesson-quiz-card-container {
  padding: 2rem 2rem;
  background-color: var(--brand-color-with-opacity-01);
  text-align: center;
  border-radius: $border-radius;

  .lesson-quiz-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .icon-container {
    color: white;
    font-size: 1.25rem;
    border-radius: 50%;
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.status-failed {
    background-color: rgba($coral, 0.1);

    .icon-container {
      background-color: var(--brand-color);
    }
  }

  &.status-passed {
    background-color: rgba($forest, 0.1);

    .icon-container {
      background-color: $forest;
    }
  }

  &.status-review {
    background-color: rgba($blue, 0.1);

    .icon-container {
      background-color: $blue;
    }
  }
}
</style>
